// extracted by mini-css-extract-plugin
module.exports = {"modal":"promptPopup_modal__ZkGon"};